module.exports = __webpack_public_path__ + "img/news6-4.2da23aa9.png";